import { render, staticRenderFns } from "./checkout-page.vue?vue&type=template&id=4bc8b143&scoped=true"
import script from "./checkout-page.vue?vue&type=script&lang=js"
export * from "./checkout-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc8b143",
  null
  
)

export default component.exports